import { Space } from 'antd';
import styled from 'styled-components';

export const StyledWrapper = styled(Space)`
  padding: 64px 0;
  width: 100%;
  height: 100%;
  justify-content: center;
`;
